import { useState } from "react";
import styles from "./DataProvidedBy.module.scss";
import clsx from "clsx";
import { Logo } from "../Logo";
import { innoveraLogoSrc } from "../../const/const";
import { Typography } from "../Typography";
import { WarningCircle1Icon } from "../../assets/icons";
import { StackIcon } from "../../assets/icons/StackIcon";
import { useScreenWidth } from "../../lib/hooks/useScreenWidth";

export interface DataProvidedByProps {
  companyName?: string | null;
  companyLogoSrc?: string | null;
  isByInnovera: boolean;
  viewSourceHref?: string | (() => void) | null;
  onReportError?: () => void;
}

export function DataProvidedBy(props: DataProvidedByProps) {
  const { companyName, companyLogoSrc, isByInnovera, viewSourceHref, onReportError } = props;
  const viewSourceAction = typeof viewSourceHref === "string" ? () => window.open(viewSourceHref) : viewSourceHref;
  const isMobile = useScreenWidth() <= 768;
  return (
    <div className={clsx(styles.container, isByInnovera ? styles.innoveraContainer : styles.customContainer)}>
      <div className={styles.leftContainer}>
        <div className={styles.logoContainer}>
          <Logo logo={isByInnovera ? innoveraLogoSrc : companyLogoSrc} size="px20" />
        </div>
        {/* <div className={styles.providedContainer}> */}
        <Typography
          variant="body-3"
          color={isByInnovera ? "innovera-orange700" : "greyscale700"}
          className={styles.textContainer}
        >
          {/* Data Provided by {isByInnovera ? "Innovera" : companyName || "the company"}  */}
          Data {!!companyName ? "provided" : isByInnovera ? "curated" : "provided"} by{" "}
          {!!companyName ? companyName : isByInnovera ? "Innovera" : "the company"}
        </Typography>
        {/* </div> */}
      </div>
      <div className={styles.rightContainer}>
        {isByInnovera && (
          <>
            {!!onReportError && (
              <div className={clsx(styles.reportError, styles.opacity60)} onClick={onReportError}>
                <div className={styles.rightIcons}>
                  <WarningCircle1Icon />
                </div>
                {!isMobile && (
                  <Typography variant="body-3" color="innovera-orange900">
                    Report an Error
                  </Typography>
                )}
              </div>
            )}
            {!!viewSourceAction && (
              <div className={clsx(styles.viewSource, styles.opacity60)} onClick={viewSourceAction}>
                <div className={styles.rightIcons}>
                  <StackIcon />
                </div>
                {!isMobile && (
                  <Typography variant="body-3" color="innovera-orange900">
                    View Source
                  </Typography>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
